import { Injectable } from '@angular/core';
import {SettingsService} from '../core/settings.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CompareService {

  constructor(
    private httpClient: HttpClient,
    private settingsService: SettingsService
  ) {}

  getCompareData(ids: string[]) {
    return this.httpClient.get(
      this.settingsService.getSetting('apiHost') + 'compare/profile/data',
      {
        params: {
          'ids[]': ids
        }
      }
    );
  }

  prepareCompareStat(data: any) {
    let out = {
      score: {
        data: [],
        min: 0,
        max: 0
      },
      follower_engage: {
        data: [],
        min: 0,
        max: 0
      },
      followed_by: {
        data: [],
        min: 0,
        max: 0
      },
      real_people: {
        data: [],
        min: 0,
        max: 0
      },
      true_er: {
        data: [],
        min: 0,
        max: 0
      },
      like_avg: {
        data: [],
        min: 0,
        max: 0
      },
      comment_avg: {
        data: [],
        min: 0,
        max: 0
      }
    };
    for (const i in data) {
      const d = data[i];
      if (d.audit.status === 2) {
        out.score.data.push(d.score.score);
        out.follower_engage.data.push(d.follower_engage.engage_count);
        out.followed_by.data.push(d.instagram_user.followed_by);
        out.real_people.data.push(d.follower_stat.followers.real_people.percent);
        out.true_er.data.push(d.engage_indicator.trueEr);
        out.like_avg.data.push(d.media_stat.like.true_media_avg.value);
        out.comment_avg.data.push(d.media_stat.comment.true_media_avg.value);
      }
    }

    for (const p in out) {
      out[p].max = Math.max(...out[p].data);
      out[p].min = Math.min(...out[p].data);
    }

    return out;
  }
}
